// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CoverMyMedsV1ClientGeneratedWorkflowModel {
    'name'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CoverMyMedsV1ClientGeneratedWorkflowModel>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CoverMyMedsV1ClientGeneratedWorkflowModel.attributeTypeMap;
    }
}
